export const enTranslations = {
  loading: {
    message: 'Stay tuned to see live coverage updates'
  },
  not_found: {
    message: "Sorry, we don't recognise this vehicle."
  },
  beneficiary_location: {
    found: {
      message: 'You have been located at the following address:',
      address_inline: '{number} {street_name}, {city_zip} {city_name}, {country}'
    },
    sent: {
      title: 'Your location has been sent',
      subtitle: 'Your roadside assistant is on the way'
    },
    modify_btn_content: 'Modify',
    confirm_btn_content: 'Yes, the address is correct',
    button_loading_content: 'GPS position calculation in progress',
    accuracy_estimate: 'Estimated accuracy: ~{accuracy} m',
    ask: {
      underground_question: 'Is the vehicle in an area with height restrictions?',
      underground_yes: 'Yes',
      underground_no: 'No',
      manual_fallback_info: 'Unable to get your GPS position. Please enter your address manually.'
    }
  },
  manual_geolocation: {
    address_input_placeholder: 'Enter the address here...',
    save_btn_content: 'Save',
    cancel_btn_content: 'Cancel',
    title: 'Enter your exact location:'
  },
  share_position: {
    geolocation_refused: {
      ios_device: "Geolocation is not allowed. <a target='_blank' href='https://zupple.fr/go/faq/activer-la-geolocalisation-sous-ios/'>Here is a guide to enable geolocation on your device.</a>",
      android_device: "Geolocation is not allowed. <a target='_blank' href='https://support.google.com/chrome/answer/142065?hl=en&co=GENIE.Platform%3DAndroid'>Here is a guide to enable geolocation on your device.</a>",
      no_mobile_device: 'Geolocation is not allowed. Please enable it so that your roadside assistant can locate you'
    },
    geolocation_not_available: 'Error: unable to retrieve the position.',
    geolocation_too_long: 'Error: retrieving the position took too long'
  },
  message_composer: {
    placeholder: 'Type your message',
    submit: 'Send'
  },
  truck_en_route: {
    tow_truck_image: {
      alt: 'Tow truck'
    },
    message_with_truck_image: 'Good news! {first_name}, one of our best roadside assistants, is on the way to help you. On arrival, please verify their identity using the licence plate and the truck photo provided.',
    message_without_truck_image: 'Good news! {first_name}, one of our best roadside assistants, is on the way to help you. On arrival, please verify their identity using the licence plate.'
  },
  guided_depollution: {
    vehicle_photo_alt: 'Intervention vehicle'
  },
  missions_infos: {
    driver_name: {
      title: 'Your roadside assistant'
    },
    company_name: {
      title: 'Your roadside assistance company'
    }
  },
  notifications: {
    modal_title: 'Stay informed',
    prompt: 'Enable notifications to be alerted as soon as your tow truck operator sends you a message.',
    enable_button: 'Enable notifications',
    decline_button: 'Maybe later'
  }
}
